<template>
    <div class="component">
        <vue-headful
                title="Methods List | W&S Docs"
        />
        <div v-if="loading" class="loading">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <ul class="list-group list-group-horizontal mb-3">
            <li class="list-group-item bg-dark d-flex align-items-center justify-content-between" v-for="(theme, index) in themes" :key="index">
                <div class="form-group m-0">
                    <router-link :to="'/methods/' + theme.theme_link">{{ theme.theme_title }}</router-link>
                </div>
            </li>
        </ul>

        <ul class="list-group list-group-flush">
            <li class="list-group-item bg-dark d-flex align-items-center justify-content-between" v-for="(method, index) in methods" :key="index">
                <div class="form-group m-0">
                    <router-link :to="'/methods/' + method.theme_link + '/' + method.method_link">{{ method.method_link }}</router-link>
                    <small class="form-text text-muted">{{ method.method_desc }}</small>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: "MethodsList",
        data() {
            return {
                methods: [],
                themes: [],
                loading: true,
                result: false
            }
        },
        mounted() {
            axios.get('https://api.write-and-share.ml/docs/method.get')
                .then(response => {
                    this.methods = response.data.response
                });
            axios.get('https://api.write-and-share.ml/docs/theme.get')
                .then(response => {
                    this.themes = response.data.response
                });
            this.loading = false
        },
    }
</script>

<style scoped>

</style>
